import { call, put, select } from 'redux-saga/effects';
import { apiAction, get, mapStateToArgs, pageContext } from 'ctm-util-functions';

/**
 * Saga to create apiAction that saves marketing info by calling BE services
 */
export const saveMarketing = function* () {
    const pageState = pageContext.getProps().pageState || {};
    const settings = pageContext.getProps().models.pageSchemaModel.getSettings();
    const apiSchema = yield call(get, settings, 'api.saveMarketing', null);
    if (apiSchema) {
        const restArgs = yield select(mapStateToArgs, apiSchema.restArgs);
        const action = apiAction(apiSchema, pageState, restArgs);
        yield put(action);
    }
};
